import React, { useEffect, useRef, useState } from 'react';
// Build "legacy" para compatibilidad con Create React App (webpack 5) y Node 18.
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';
import styles from './PdfCanvasViewer.module.css';

// Configura el worker una sola vez.
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

// Renderiza un PDF página por página en <canvas> (evita el visor nativo del
// navegador y su botón de descarga) con una marca de agua superpuesta.
const PdfCanvasViewer = ({ url, watermarkText = 'By Raíces', scale = 1.4 }) => {
  const containerRef = useRef(null);
  const [status, setStatus] = useState('loading'); // 'loading' | 'ready' | 'error'
  const [numPages, setNumPages] = useState(0);

  useEffect(() => {
    let cancelled = false;
    let loadingTask = null;
    const container = containerRef.current;

    const render = async () => {
      if (!url || !container) return;
      setStatus('loading');
      container.innerHTML = '';
      try {
        loadingTask = pdfjsLib.getDocument({ url, withCredentials: false });
        const pdf = await loadingTask.promise;
        if (cancelled) return;
        setNumPages(pdf.numPages);

        for (let n = 1; n <= pdf.numPages; n++) {
          const page = await pdf.getPage(n);
          if (cancelled) return;
          const viewport = page.getViewport({ scale });

          const pageWrap = document.createElement('div');
          pageWrap.className = styles.pageWrap;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.className = styles.canvas;

          const overlay = document.createElement('div');
          overlay.className = styles.watermark;
          overlay.textContent = watermarkText;
          overlay.setAttribute('aria-hidden', 'true');

          pageWrap.appendChild(canvas);
          pageWrap.appendChild(overlay);
          container.appendChild(pageWrap);

          await page.render({ canvasContext: ctx, viewport }).promise;
          if (cancelled) return;
        }
        setStatus('ready');
      } catch (err) {
        if (!cancelled) setStatus('error');
      }
    };

    render();

    return () => {
      cancelled = true;
      if (loadingTask?.destroy) loadingTask.destroy();
      if (container) container.innerHTML = '';
    };
  }, [url, scale, watermarkText]);

  return (
    <div className={styles.viewer} onContextMenu={(e) => e.preventDefault()}>
      {status === 'loading' && <p className={styles.info}>Cargando documento…</p>}
      {status === 'error' && (
        <p className={styles.error}>No se pudo mostrar el documento PDF.</p>
      )}
      <div ref={containerRef} className={styles.pages} />
      {status === 'ready' && numPages > 0 && (
        <p className={styles.info}>{numPages} página{numPages > 1 ? 's' : ''}</p>
      )}
    </div>
  );
};

export default PdfCanvasViewer;
